import styles from "./profile.module.scss"
import classNames from "classnames"
import { Avatar } from "@mui/material"
import Link from "next/link"
import { ReactNode } from "react"
import StyledText from "../../../typography/typography-component"
import skColors from "../../../../styles/skColors"

interface ProfileProps {
  name?
  title?: string | ReactNode
  className?
  src
  onClick?
  href?
  blue?: boolean
  newImageFix?: boolean

  [key: string]: unknown
}

const Profile = ({ name, title, className, newImageFix = false, src, onClick, href, blue, ...other }: ProfileProps) => {
  const profileContainerClasses = classNames(styles.profile, className, {
    [styles.profileMarginBottom]: !!title || !!name,
    [styles.advisorWidth]: blue
  })

  if (!!href) {
    return (
      <div className={profileContainerClasses} {...other}>
        <Link href={href}>
          <Avatar
            onClick={onClick}
            className={classNames(styles.avatar, {
              [styles.avatarBlue]: blue,
              [styles.avatarWhite]: !blue,
              [styles.newImageFix]: newImageFix,
            })}
            alt={name}
            src={src}
          />
        </Link>
        {name && <StyledText variant={"pSmall"} className={styles.profileName}>{name}</StyledText>}
        {typeof title == "string" ? <StyledText variant={"tags"} color={skColors.turquoise[600]} className={styles.profileTitle}>{title}</StyledText> : title}
      </div>
    )
  } else {
    return (
      <div className={profileContainerClasses} {...other}>
        <Avatar
          onClick={onClick}
          className={classNames(styles.avatar, {
            [styles.avatarBlue]: blue,
            [styles.avatarWhite]: !blue,
          })}
          alt={name}
          src={src}
        />
        {name && <StyledText variant={"pSmall"} className={styles.profileName}>{name}</StyledText>}
        {title && <StyledText variant={"tags"} color={skColors.turquoise[600]} className={styles.profileTitle}>{title}</StyledText>}
      </div>
    )
  }
}
export default Profile
